if (!customElements.get('poster-purchase')) customElements.define('poster-purchase', class extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form'); this.status = this.querySelector('[role="status"]');
    this.form.addEventListener('submit', event => this.add(event));
    this.form.elements.size.addEventListener('change', () => this.materials());
    this.form.elements.material.addEventListener('change', () => this.price());
    this.load();
  }
  async load() {
    try {
      const id = new URLSearchParams(location.search).get('artwork');
      if (!id || !/^[A-Za-z0-9_-]{1,80}$/.test(id)) { this.status.textContent = this.dataset.select; return; }
      const endpoint = new URL(this.dataset.endpoint);
      if (endpoint.protocol !== 'https:') throw new Error('HTTPS required');
      endpoint.pathname = endpoint.pathname.replace(/\/$/, '') + '/' + encodeURIComponent(id);
      const response = await fetch(endpoint, {credentials:'omit'});
      if (!response.ok) throw new Error('Artwork unavailable');
      this.item = await response.json();
      if (this.item.id !== id || !this.item.variants.length) throw new Error('Artwork mismatch');
      const preview = new URL(this.item.previewUrl, endpoint.origin);
      if (preview.origin !== endpoint.origin) throw new Error('Invalid preview');
      this.preview = preview.href;
      const image = this.querySelector('[data-image]'); image.src = preview.href; image.alt = this.item.title; image.hidden = false;
      this.querySelector('[data-title]').textContent = this.item.title;
      this.querySelector('[data-category]').textContent = this.item.category;
      this.querySelector('[data-description]').textContent = this.item.description || '';
      document.title = this.item.title + ' – SuperPoster';
      for (const size of [...new Set(this.item.variants.map(v => v.size))]) this.option(this.form.elements.size, size);
      this.materials(); this.form.hidden = false; this.status.textContent = '';
    } catch (error) { this.status.textContent = this.dataset.error; }
  }
  option(select, value) { const option = document.createElement('option'); option.value = option.textContent = value; select.append(option); }
  materials() {
    const select = this.form.elements.material; const previous = select.value; select.replaceChildren();
    for (const material of [...new Set(this.item.variants.filter(v => v.size === this.form.elements.size.value).map(v => v.material))]) this.option(select, material);
    if ([...select.options].some(o => o.value === previous)) select.value = previous;
    this.price();
  }
  selected() { return this.item.variants.find(v => v.size === this.form.elements.size.value && v.material === this.form.elements.material.value); }
  price() {
    const variant = this.selected(); this.form.querySelector('button').disabled = !variant;
    this.querySelector('[data-price]').textContent = variant ? new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:this.dataset.currency}).format(Number(variant.price)) : '';
  }
  async add(event) {
    event.preventDefault(); const variant = this.selected(); if (!variant || !this.form.reportValidity()) return;
    const button = this.form.querySelector('button'); button.disabled = true; this.status.textContent = '';
    try {
      const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:Number(variant.id),quantity:Number(this.form.elements.quantity.value),properties:{Poster:this.item.title,'_artwork_id':this.item.id,'_image_sku':variant.imageSku,'_original_ref':'poster://artwork/'+this.item.id,'_preview_url':this.preview}}]})});
      const result = await response.json(); if (!response.ok) throw new Error(result.description || this.dataset.error);
      this.status.textContent = this.dataset.added; location.assign((window.Shopify?.routes?.root || '/') + 'cart');
    } catch (error) { this.status.textContent = error.message || this.dataset.error; button.disabled = false; }
  }
});
